import React, { useState } from 'react'
import { Box, Typography, Skeleton } from '@mui/material'

type ApiStats = {
  brokers_monitored: number | null
  clean_scans: number | null
  records_in_progress: number | null
}

type TimePeriodStatsProps = {
  last_7_days?: ApiStats | null
  last_30_days?: ApiStats | null
}

const TimePeriodStats: React.FC<TimePeriodStatsProps> = ({ 
  last_7_days = null, 
  last_30_days = null, 
}) => {
  const [activeTab, setActiveTab] = useState<'7' | '30'>('7')

  const data = activeTab === '7' ? last_7_days : last_30_days

  return (
    <>
      {/* Tabs */}
      <Box
        sx={{
          width: '100%',
          minHeight: '38px',
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          mt: '20px',
        }}
      >
        <Box
          onClick={() => setActiveTab('7')}
          sx={{
            width: '130px',
            height: '38px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            borderBottom: activeTab === '7' ? '3px solid black' : '3px solid transparent',
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '18px',
              lineHeight: '22px',
              textAlign: 'center',
              color: activeTab === '7' ? 'black' : '#8C32E2',
            }}
          >
            Last 7 days
          </Typography>
        </Box>

        <Box
          onClick={() => setActiveTab('30')}
          sx={{
            width: '130px',
            height: '38px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            borderBottom: activeTab === '30' ? '3px solid black' : '3px solid transparent',
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '18px',
              lineHeight: '22px',
              textAlign: 'center',
              color: activeTab === '30' ? 'black' : '#8C32E2',
            }}
          >
            Last 30 days
          </Typography>
        </Box>
      </Box>

      {/* Cards */}
      <Box
        sx={{
          width: '100%',
          minHeight: '148px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '24px',
          mt: '20px',
        }}
      >
        <StatCard
          title="Records in Progress"
          value={data?.records_in_progress}
          subtitle="Records awaiting broker action."
        />

        <StatCard
          title="Brokers Monitored"
          value={data?.brokers_monitored}
          subtitle="Total brokers under surveillance."
        />

        <StatCard
          title="Clean Scans"
          value={data?.clean_scans}
          subtitle="Brokers scanned with no data found."
        />
      </Box>
    </>
  )
}


type StatCardProps = {
  title: string
  value: number | null | undefined
  subtitle: string
}

const StatCard: React.FC<StatCardProps> = ({ title, value, subtitle }) => {
  return (
    <Box
      sx={{
        width: { xs: '100%', sm: '100%', md: '355px', lg: '339px' },
        height: '148px',
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
        p: '29px 22px',
        borderRadius: '7px',
        backgroundColor: '#fff',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <Box>
        <Typography sx={{ fontSize: '14px', fontWeight: 500, textTransform: 'uppercase' }}>
          {title}
        </Typography>
        {value !== null && value !== undefined ? (
          <Typography sx={{ fontSize: '24px', fontWeight: 600, textTransform: 'uppercase' }}>
            {value}
          </Typography>
        ) : (
          <Skeleton variant="text" width={80} height={36} />
        )}
      </Box>
      <Typography sx={{ fontSize: '12px' }}>{subtitle}</Typography>
    </Box>
  )
}

export default TimePeriodStats
